import React from "react";
import { Link } from "react-router-dom";
import defaultUser from "../../../assets/defaultUser.png";

const Logo = () => {
  return (
    <Link to="/" className="flex items-center justify-center w-full"> 
                  <img
              className="rounded-full cursor-pointer"
              src={defaultUser}
              alt="userProfileImage"
              width={200}
            />
      <div className="font-monoton text-3xl hover:text-red-800 cursor-pointer text-center transition">

      </div>
    </Link>
  );
};

export default Logo;
